module.exports = __webpack_public_path__ + "assets/img/e13cc81ecd272bf9cad45ceeef49a4b8.webp";